import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import Menu from '@mui/material/Menu';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledTabs = /*#__PURE__*/_styled(Tabs, {
  shouldForwardProp: isStyledPropsValid,
  target: "eysu2lm3"
})(_ref => {
  return {
    minHeight: 'unset',
    '& .MuiTabs-scrollButtons': {
      '&.Mui-disabled': {
        opacity: 0.3
      }
    }
  };
}, "");
const StyledTab = /*#__PURE__*/_styled(Tab, {
  shouldForwardProp: isStyledPropsValid,
  target: "eysu2lm2"
})(_ref2 => {
  let {
    theme,
    sx
  } = _ref2;
  return _objectSpread2({
    fontSize: '14px',
    fontWeight: 600,
    opacity: 0.7,
    padding: '9.5px 15px',
    minHeight: 'unset',
    textTransform: 'unset',
    '&:hover': {
      opacity: 1
    },
    '&.Mui-selected': {
      color: theme.customColors.grey[700],
      backgroundColor: theme.customColors.purple[300],
      opacity: 1
    }
  }, sx);
}, "");
const StyledMenu = /*#__PURE__*/_styled(Menu, {
  shouldForwardProp: isStyledPropsValid,
  target: "eysu2lm1"
})(_ref3 => {
  return {
    '& .MuiList-root': {
      padding: '4px',
      paddingTop: '4px',
      paddingB: '4px'
    }
  };
}, "");
export { StyledMenu, StyledTab, StyledTabs };